// extracted by mini-css-extract-plugin
module.exports = {"honer":"honor_honer__2d-Z7","con":"honor_con__1LTny","warp":"honor_warp__1Hmta","itm":"honor_itm__30VBc","img":"honor_img__2PppH","dec":"honor_dec__27qEQ","tet":"honor_tet__2Rure"};